"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "DefaultLogger", {
  enumerable: !0,
  get: function get() {
    return _defaultLogger.DefaultLogger;
  }
}), Object.defineProperty(exports, "IExternalLogger", {
  enumerable: !0,
  get: function get() {
    return _types.IExternalLogger;
  }
}), Object.defineProperty(exports, "KameleoonLogger", {
  enumerable: !0,
  get: function get() {
    return _kameleoonLogger.KameleoonLogger;
  }
}), Object.defineProperty(exports, "LogLevel", {
  enumerable: !0,
  get: function get() {
    return _types.LogLevel;
  }
});
var _types = require("./types"),
  _kameleoonLogger = require("./kameleoonLogger"),
  _defaultLogger = require("./defaultLogger");